import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
//Styles
import { useStyles } from 'components/sheets/AccountManageModuleSheets/AccountManageSheets.style';
//Mui components
import { IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, Switch, TextField } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
//Actions
import AlertAction from 'actions/AlertAction';

const ManageDmSheet = ({
    activeModule,
    config,
    setActiveModule,
    setConfig,
}) => {

    const classes = useStyles();

    const [emailToAdd, setEmailToAdd] = useState('');

    const inputEl = useRef(null);

    const addEmail = () => {
        if (emailToAdd === '') return;
        if (config.emailAddresses.includes(emailToAdd)) {
            AlertAction.open('info','Email déja existant', 'top-right');
            return;
        }
        const newConfig = Object.assign({}, config);
        newConfig.emailAddresses.push(emailToAdd);
        setConfig(newConfig);
        setEmailToAdd('');
    };

    const deleteEmail = (emailToDelete) => {
        const newConfig = Object.assign({}, config);
        newConfig.emailAddresses = newConfig.emailAddresses.filter(email => email !== emailToDelete);
        setConfig(newConfig);
    };

    const editEmail = (emailToEdit) => {
        deleteEmail(emailToEdit);
        setEmailToAdd(emailToEdit);
        inputEl.current.focus();
    };

    return <div className={classes.moduleManageContainer}>
        <div className={classes.activeModule}>
            <div className={classes.titleText}>
                Activer le module Daily Monitoring pour le compte
            </div>
            <Switch checked={activeModule} onChange={() => setActiveModule(!activeModule)} />
        </div>
        <div className={classes.form}>
            <div className={classes.formText}>
                Email
            </div>
            <TextField
                label='Email à ajouter'
                inputRef={inputEl}
                value={emailToAdd}
                variant='outlined'
                size='small'
                onChange={event => setEmailToAdd(event.target.value)}
                className={classes.moduleSiteSelect}
                onKeyDown={(event) => event.key === 'Enter' && addEmail()}
            />
            <IconButton onClick={() => addEmail()} style={{ marginLeft: '5px' }}>
                <AddIcon color='primary'/>
            </IconButton>
        </div>
        <List dense={true}>
            {config.emailAddresses.map(email => <ListItem key={email} style={{ marginLeft: '25px' }}>
                <ListItemText>
                    {email}
                </ListItemText>
                <ListItemSecondaryAction>
                    <IconButton onClick={() => editEmail(email)} style={{ marginLeft: '5px' }}>
                        <EditIcon />
                    </IconButton>
                    <IconButton onClick={() => deleteEmail(email)} style={{ marginLeft: '5px' }}>
                        <DeleteIcon color='red'/>
                    </IconButton>
                </ListItemSecondaryAction>
            </ListItem>)}
        </List>
    </div>;
};

ManageDmSheet.propTypes = {
    activeModule: PropTypes.bool,
    config: PropTypes.object,
    setActiveModule: PropTypes.func,
    setConfig: PropTypes.func,
    sites: PropTypes.array
};

export default ManageDmSheet;
